import { useMemo } from 'react';

const useItemAttributesTabs = (itemAttributes = [], attributesToDisplay) => {

    return useMemo(() => {
        

        return attributesToDisplay?.map(section => {
            let content = {
                title: section.SectionTitle,
                attributes: []
            };

            section.ItemAttributes.forEach(attr => {
                const matchingItem = itemAttributes.find(item => item.AttributeName === attr.PimProperty);
    
                if (matchingItem) {
                    content.attributes.push({
                        attributeName: matchingItem.AttributeName,
                        value: matchingItem.Values,
                        attributeKey: attr.AttributeKey
                    })
                }
            })

            return content;
        })
        
        
    }, [itemAttributes, attributesToDisplay]);
};

export default useItemAttributesTabs;
